/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Col_CountryInputs */



/**
* | output |
* | --- |
* | "Country" |
*
* @param {Tournaments_Col_CountryInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_col_country = /** @type {((inputs?: Tournaments_Col_CountryInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Col_CountryInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pays")
	if (locale === "es") return /** @type {LocalizedString} */ ("País")
	if (locale === "pt") return /** @type {LocalizedString} */ ("País")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nazione")
	return /** @type {LocalizedString} */ ("Country")
});